const initialConsentTemplateValues = {
	templateName: '',
	templateDescription: '',
	purpose: {
		code: '',
		text: '',
		customPurposeText:'',
		refUri: '',
		Category: {
			type: '',
		},
	},
	consentMode: 'STORE',
	fiType: [],
	consentType: ['PROFILE', 'SUMMARY', 'TRANSACTIONS'],
	frequency: '',
	frequencyPeriod: {
		value: '1',
		unit: 'YEAR',
	},
	consentStart: 0,
	consentExpiry: {
		value: '',
		unit: '',
	},
	dataFilter: {
		type: 'TRANSACTIONAMOUNT',
		operator: '>',
		value: '0',
	},
	dataLife: {
		value: '',
		unit: '',
	},
	dataRange: {
		value: '',
		unit: '',
	},
};

export default initialConsentTemplateValues;
